import React, {useEffect, useState} from "react";
import CustomDialog from "../../components/general/CustomDialog";
import {useTranslation} from "react-i18next";
import {toBase64} from "../../utils/fileBase64";
import FileUpdate from "../../components/general/file-update/FileUpdate";
import {DocumentProcessInterface} from "../../services/interface/DocumentProcessInterface";
import CustomButton from "../../components/general/CustomButton";
import {useSaveDocumentProcess} from "../../services/process/apiProcess";
import {enqueueSnackbar} from "notistack";
import {ProcessDto} from "../../services/interface/ProcessDtoInterface";
import {useProcessStore} from "../../services/storage/process/ProcessStorage";
import {DescriptionFileInterface} from "../../services/interface/DescriptionFileInterface";

interface Props {
    process: ProcessDto;
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function DialogAddDocuments({process, open, setOpen}: Props) {
    const {t} = useTranslation("global") as { t: (key: string) => string }
    const dialogBodyRef = React.useRef<HTMLDivElement | null>(null);

    const {mutate: saveDoc, isPending: isLoadingDocumentSave, data: successDocumentSave} = useSaveDocumentProcess();
    const setProcessStorage = useProcessStore(data => data.setData)

    const [files, setFiles] = useState<File[]>([]);
    const [descriptions, setDescriptions] = useState<DescriptionFileInterface[]>([]);
    const [filesFormat, setFilesFormat] = useState<DocumentProcessInterface[]>([]);

    useEffect(() => {
        if (files && files.length > 0) {
            const filesBase64: DocumentProcessInterface[] = []
            files.forEach(item => {
                toBase64(item)
                    .then((base64String) => {
                        const aux: any = base64String ? base64String : ','
                        const file: DocumentProcessInterface = {
                            name: item.name,
                            type: item.type,
                            size: item.size,
                            file: aux.split(',')[1],
                            date: new Date()
                        }
                        filesBase64.push(file)
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            })
            setFilesFormat(filesBase64)
            scrollAction()
        }
    }, [files]);

    const scrollAction = () => {
        if (dialogBodyRef && dialogBodyRef.current && dialogBodyRef.current?.scrollHeight && dialogBodyRef.current?.clientHeight) {
            const fullHeight = dialogBodyRef.current?.scrollHeight - dialogBodyRef.current?.clientHeight;

            dialogBodyRef.current?.scrollTo({
                top: fullHeight,
                behavior: 'smooth',
            });
        }
    }

    useEffect(() => {
        if (successDocumentSave) {
            enqueueSnackbar(`Documento: ${successDocumentSave.name} guardado exitosamente`, { variant: 'success' });
            setTimeout(() => {setProcessStorage(process)}, 4000);
            setOpen(false)
        }
    }, [successDocumentSave]);

    return (
        <CustomDialog
            loading={isLoadingDocumentSave}
            title={t('attach-docs')}
            body={
                <div className={'flex flex-col gap-3'} ref={dialogBodyRef}>
                    <FileUpdate
                        accept={'.pdf,.zip,.rar'}
                        acceptDragAndDrop={[
                            'application/pdf',
                            'application/x-rar-compressed',
                            'application/zip',
                            'application/x-zip-compressed', // compatibilidad para navegadores antiguos
                        ]}
                        {...{files, setFiles, descriptions, setDescriptions}}
                    />
                    <CustomButton
                        className={'bg-success ml-auto'}
                        text={t('save')}
                        disabled={isLoadingDocumentSave}
                        loading={isLoadingDocumentSave}
                        onClick={() => {
                            if (filesFormat && filesFormat.length > 0) {
                                enqueueSnackbar('Guardando documentación en el repositorios', { variant: 'info' });
                                filesFormat.forEach((file, index) => {
                                    const descriptionItem = descriptions.find(item => item.index === index);
                                    saveDoc({
                                        ...file,
                                        idProcess: process?.idProcess,
                                        ...(descriptionItem?.description ?
                                            {description: descriptionItem.description} : {})
                                    });
                                })
                            }
                        }}
                    />
                </div>
            }
            {...{open, setOpen}}
        />
    )
}
